<template>
    <icon-base v-bind="$props">
        <path
            d="M4 6a1 1 0 0 1 1 -1h3.586a1 1 0 0 1 .707 .293l1.414 1.414a1 1 0 0 0 .707 .293h7.586a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
        />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
